/**
 * Formato de moneda para MXN (solo visualización).
 * El envío al API debe usar números parseados con `parseMoneyInputToNumber`.
 */
const mxnFormatter = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatMoneyDisplay(n: number): string {
  if (!Number.isFinite(n)) return '';
  return mxnFormatter.format(n);
}

/**
 * Interpreta texto de entrada (con o sin símbolo $, MXN, separadores es-MX o en-US).
 */
export function parseMoneyInputToNumber(s: string): number {
  if (!s || typeof s !== 'string') return NaN;
  let t = s
    .trim()
    .replace(/\u00a0/g, ' ')
    .replace(/\s/g, '');
  t = t.replace(/MXN/gi, '').replace(/[$€]/g, '').trim();
  if (t === '' || t === '-') return NaN;
  const lastComma = t.lastIndexOf(',');
  const lastDot = t.lastIndexOf('.');
  if (lastComma > lastDot) {
    t = t.replace(/\./g, '').replace(',', '.');
  } else {
    t = t.replace(/,/g, '');
  }
  const n = parseFloat(t);
  return n;
}
